import React from "react"

const VerticalTab = ({ setActiveTab, activeTab, currentTab, title }) => {
  const activeClasses = 'text-text-primary font-bold bg-primary-main/10 border-l-4 border-l-primary-main rounded-r-xl'

  return (
    <button
      className={`h-12 w-full text-start px-6 transition-colors ${activeTab === currentTab ? activeClasses : "text-text-secondary hover:bg-surface"}`}
      onClick={() => setActiveTab(currentTab)}
    >
      {title}
    </button>
  )
}

export default VerticalTab
